import loadSafeframeAssetsImpl from './loadSafeframeAssets';
import { SAFEFRAME_ASSETS_PATH } from '../../rui-env-variables';
import { track } from '../../tracking';
import { withSafeframeRenderStartedEvent, withAdLoadedEvent, withSafeframeRenderDomContentLoadedEvent, withPostbidBidCompletedEvent } from '../../tracking/events';
import { log } from '../../utils/loggingUtil';
import { IS_CLIENT } from '../../utils/browserUtils';

var receiveMessage = function receiveMessage(event) {
  var _data;

  var data;

  try {
    data = JSON.parse(event.data);
  } catch (_unused) {
    return;
  }

  if (((_data = data) === null || _data === void 0 ? void 0 : _data.type) !== 'resizeAd') {
    return;
  }

  var _data2 = data,
      creativeWidth = _data2.creativeWidth,
      creativeHeight = _data2.creativeHeight,
      containerId = _data2.containerId,
      adPosition = _data2.adPosition;
  var adIFrame = document.getElementById(containerId);
  var safeFrameDiv = document.getElementById("sf_pos_rel_el_".concat(containerId));

  if (!adIFrame || !safeFrameDiv) {
    return;
  }

  adIFrame.style.height = "".concat(creativeHeight, "px");
  safeFrameDiv.style.height = "".concat(creativeHeight, "px");
  adIFrame.style.width = "".concat(creativeWidth, "px");
  safeFrameDiv.style.width = "".concat(creativeWidth, "px");
  log('adPosition:', adPosition);
  log('adSizeWidth:', creativeWidth);
  log('adSizeHeihgt:', creativeHeight);
  log('adId:', containerId);
};

IS_CLIENT && window.addEventListener('message', receiveMessage, false);

var generateSafeframeAd = function generateSafeframeAd(adSpot, shouldTrackEvent) {
  var loadSafeframeAssets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : loadSafeframeAssetsImpl;
  var currentWindow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
  var safeframeCdn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : SAFEFRAME_ASSETS_PATH;
  var container = adSpot.element,
      containerId = adSpot.guid,
      _loadCompleteCallback = adSpot.loadCompleteCallback,
      _resizeCompleteCallback = adSpot.resizeCompleteCallback,
      nativeContent = adSpot.nativeContent,
      prebidSize = adSpot.prebidSize,
      allowSandboxTopNavByUserActivation = adSpot.allowSandboxTopNavByUserActivation;
  adSpot.insertAdvertisementHeading();
  var adLink = adSpot.getLink();
  var availableSizes = prebidSize || adSpot.getAvailableSizes().replace(',native', '');
  var initialSize = prebidSize || adSpot.getInitialSize(availableSizes);
  var isMultiSize = adSpot.isMultiSize(availableSizes);
  var autoHide = String(adSpot.config.autoHide) === 'true';
  container.id = containerId;
  return loadSafeframeAssets().then(function () {
    var _currentWindow$$sf;

    var html;

    if (nativeContent !== undefined) {
      html = nativeContent;
    } else if (adSpot.prebidAdId) {
      html = !adSpot.isDemoApp ? "<iframe frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" topmargin=\"0\" leftmargin=\"0\" allowtransparency=\"true\" width=\"0\" height=\"0\" src='".concat(safeframeCdn, "/html/prebidSafeframe.html?adId=").concat(adSpot.prebidAdId, "'></iframe>") : "<iframe frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" topmargin=\"0\" leftmargin=\"0\" allowtransparency=\"true\" width=\"0\" height=\"0\" src='".concat(safeframeCdn, "/html/prebidSafeframe.html?adId=").concat(adSpot.prebidAdId, "&isDemoApp=").concat(adSpot.isDemoApp, "'></iframe>");
    } else {
      html = "<script src=\"".concat(adLink, "\" type=\"text/javascript\" id=\"adScript\"></script>");
    }

    if (!(currentWindow !== null && currentWindow !== void 0 && (_currentWindow$$sf = currentWindow.$sf) !== null && _currentWindow$$sf !== void 0 && _currentWindow$$sf.host)) {
      return;
    }

    if (!currentWindow.$sf.host.Config()) {
      new currentWindow.$sf.host.Config({
        renderFile: "".concat(safeframeCdn, "/html/r.html")
      });
    }

    new currentWindow.$sf.host.PosConfig({
      id: containerId,
      size: initialSize,
      tgt: '_blank',
      supports: {
        'exp-push': isMultiSize
      },
      autoHide: autoHide,
      loadCompleteCallback: function loadCompleteCallback(adProperties) {
        if (typeof _loadCompleteCallback === 'function') {
          _loadCompleteCallback(adProperties, adProperties.isAdLoaded);
        }

        track(withAdLoadedEvent({
          loadedType: adProperties.loadedType
        }), adSpot, shouldTrackEvent);
      },
      resizeCompleteCallback: function resizeCompleteCallback(adProperties) {
        if (typeof _resizeCompleteCallback === 'function') {
          _resizeCompleteCallback(adProperties, adProperties.isAdLoaded);
        }
      },
      safeframeRenderDomContentLoadedCallback: function safeframeRenderDomContentLoadedCallback() {
        track(withSafeframeRenderDomContentLoadedEvent(), adSpot, shouldTrackEvent);
      },
      postbidBidCompletedCallback: function postbidBidCompletedCallback(adProperties) {
        track(withPostbidBidCompletedEvent(adProperties), adSpot, shouldTrackEvent);
      },
      isPrebid: !!prebidSize,
      allowSandboxTopNavByUserActivation: allowSandboxTopNavByUserActivation
    }, containerId);
    var posMeta = new currentWindow.$sf.host.PosMeta({
      isMultiSize: isMultiSize,
      currentSize: initialSize,
      availableSizes: availableSizes,
      clientHeight: currentWindow.innerHeight || currentWindow.document.body.clientHeight,
      containerId: containerId,
      adPosition: adSpot.params.pos
    });
    var position = new currentWindow.$sf.host.Position(containerId, html, posMeta);
    track(withSafeframeRenderStartedEvent(), adSpot, shouldTrackEvent);
    currentWindow.$sf.host.render(position);
    return Promise.resolve('Safeframe Ad loaded');
  });
};

export default generateSafeframeAd;
//# sourceMappingURL=generateSafeframeAd.js.map